<template>
  <v-dialog
    v-model="confirmModal.isShown"
    persistent
    max-width="290"
    :retain-focus="false"
  >
    <v-card>
      <v-card-title class="headline">
        {{ confirmModal.title || 'Are you sure?' }}
      </v-card-title>
      <v-card-text v-if="confirmModal.text">{{ confirmModal.text }}</v-card-text>
      <v-card-actions>
        <v-spacer />
        <qz-btn
          color="green darken-1"
          text
          data-test="confirm-modal-yes"
          @click="hideConfirmModal(true)"
        >
          {{ confirmModal.yesButton || 'Yes' }}
        </qz-btn>
        <qz-btn
          color="green darken-1"
          text
          data-test="confirm-modal-no"
          @click="hideConfirmModal(false)"
        >
          {{ confirmModal.noButton || 'No' }}
        </qz-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import {
  mapActions,
  mapState,
} from 'vuex';

export default {
  name: 'qz-confirm',
  computed: {
    ...mapState(['confirmModal']),
  },
  methods: {
    ...mapActions(['hideConfirmModal']),
  },
};
</script>
